<div id="thrive-24">
  @if (officeHours().isOfficeHours) {
    <img
      ngSrc="assets/images/thrive-24-greyscale.webp"
      width="51"
      height="43"
      class="only-on-light"
      alt="thrive 24 coverage inactive"
      priority />
    <img
      ngSrc="assets/images/thrive-24-greyscale-white.webp"
      width="51"
      height="43"
      class="only-on-dark"
      alt="thrive 24 coverage inactive"
      priority />
    <div class="feature-name inactive">
      <p>Thrive 24</p>
      <p class="status">In-Active</p>
    </div>
  } @else {
    <img
      ngSrc="assets/images/thrive-24.webp"
      width="51"
      height="43"
      class="only-on-light"
      alt="thrive 24 coverage active"
      priority />
    <img
      ngSrc="assets/images/thrive-24-white.webp"
      width="51"
      height="43"
      class="only-on-dark"
      alt="thrive 24 coverage active"
      priority />
    <div class="feature-name">
      <p>Thrive 24</p>
      <p class="status">Active</p>
    </div>
  }
</div>
